<template>
    <section class="app-main">

        <div class="top-bar">
            <el-button  class="top-btn" type="primary" plain @click="handleShow()">添加</el-button>
            <el-button  class="top-btn" type="danger"  plain @click="handleBatch(3)" >删除</el-button>
        </div>

        <el-card shadow="hover">
            <el-table :data="tableData" @selection-change="handleChecked" empty-text="暂无管理员" height="650"  style="width:100%;">
                <el-table-column type="selection"   width="80"   align="center"> </el-table-column>
                <el-table-column prop="pic_id" label="头像"    min-width="80"    align="center">
                    <template slot-scope="scope">
                        <m-img v-if="scope.row.pic_image" :src="scope.row.pic_image.remote_url"  />
                    </template>
                </el-table-column>
                <el-table-column prop="kf"          label="昵称"      align="center"></el-table-column>
                <el-table-column prop="created_at"  label="创建时间"  align="center"   ></el-table-column>
                <el-table-column label="编辑" align="center">
                    <template slot-scope="scope">
                        <el-button type="success" plain size="small"  @click="handleShow(scope.row)">修改</el-button>
                        <el-button type="danger"  plain size="small"  @click="handleDel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
         </el-card>

        <!-- 修改角色的弹框 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialog" :show-close="false" width="600px" center>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>昵称：</p>
                </el-col>
                <el-col :span="18">
                    <el-input v-model="nickname" placeholder="请输入昵称" style="width:300px"></el-input>
                </el-col>
            </el-row>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>头像：</p>
                </el-col>
                <el-col :span="18">
                  <m-upload :img.sync="image"  :width="120" :height="120" file-name="Customer" placement="right" />
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button style="width:150px" @click="dialog = false">取 消</el-button>
                <el-button style="width:150px" type="primary" @click="handleBtn">确 定</el-button>
            </div>
        </el-dialog>


    </section>
</template>


<script>
import { cusmoter, cusmoter_add, cusmoter_put, cusmoter_del } from '@/api/platform.js'
import MUpload from '@/components/m-upload.vue'
import MImg   from './../../../components/Image'
import {parseTime} from '@/untils/index.js'
export default {
    components: { MImg, MUpload },
    data() {
        return {
            tableData: [],
            dialog:false,    // 控制显示 添加修改弹窗
            ids:[],          // table 选中数据的 id 数组集合
            dialogTitle:'添加管理员',
            id:'',           //  有id 是修改  没有id是添加
            nickname:'',
            image: {pic_id: '', url: ''},
        }
    },
    methods: {
        // 获取栏目数据
        handleData(){
            cusmoter().then(res => {
                if(res){
                    this.tableData = res.data
                    this.tableData.forEach(item => {
                        item.created_at = parseTime(item.created_at)
                    })
                }
            })
        },

        // 显示添加修改弹窗
        handleShow(row){
            if(row){
                console.log(row)
                this.dialog      = true
                this.dialogTitle = '修改管理员'
                this.id          = row.id
                this.nickname    = row.kf
                this.image       = row.pic_image
                this.image.url   = this.$store.state.config.url + this.image.url
            }else{
                this.dialog      = true
                this.dialogTitle = '添加客服'
                this.id          = ''
                this.nickname    = ''
                this.image       = {pic_id: '', url: ''}

            }
        },
        // 弹窗里面 点击确定
        handleBtn(){
            this.dialog = false
            // 通过 this.id 为空来判断 添加 || 修改
            if(this.id == ""){
                this.handleAdd()
            }else{
                this.handlePut()
            }
            
        },
        // 添加栏目函数
        handleAdd(){
            let params = {
                kf:this.nickname,
                pic_id: this.image.pic_id
            }
            cusmoter_add(params).then(res => {
                if(res){
                    this.handleData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                }
            })
        },
        // 修改栏目函数
        handlePut(){
            let params = {
                kf:this.nickname,
                pic_id: this.image.pic_id
            }
            cusmoter_put(this.id,params).then(res => {
                if(res){
                    this.handleData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                    
                }
            })
        },

         // 点击删除 
        handleDel(it){
            this.$confirm(`此操作将删除客服： ${it.kf}, 是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                cusmoter_del(it.id).then(res => {
                    this.$message({type:'success',message:res.msg})
                    this.handleData();
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        // 监听 table 选中事件，获取选中数据的id 
        handleChecked(rows){
            rows.forEach(e => {
                this.ids.push(e.id)
            })
        },
        // 批量操作  1 启用 2 禁用 3 删除
        handleBatch(){
            this.$confirm(`此操作将删除所有选中的客服, 是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                cusmoter_del(this.ids).then(res => {
                    this.$message({type:'success',message:res.msg})
                    this.handleData();
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
    },
    created(){
        this.handleData();
    },
    activated() {
        this.handleData()
    },
}
</script>

<style lang="less" scoped>
    section{
        .top-btn {
            width: 80px;
            margin-right: 15px;
        }
        .line-item {
            margin-bottom: 20px;
        }
        .input-left {
            height: 40px;
            line-height: 40px;
        }
    }
</style>